import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'starRatingNumber',
	standalone: false
})
export class StarRatingNumberPipe implements PipeTransform {
	transform(value: number, newReviewsEnhancement?: boolean): string {
		if (newReviewsEnhancement) {
			return (Math.round(10 * value) / 10).toFixed(1);
		}
		const regex = /\d+\.?\d/;
		const matchedValue = value ? regex.exec(value.toString()) : null;
		return matchedValue?.[0] || value.toFixed(1);
	}
}
